import React from "react";
import DesignForm from "./DesignForm";

export type UpdateDesignProps = Pick<
  React.ComponentProps<typeof DesignForm>,
  "design" | "switchToDesignListHandler"
>;

/** Thin mode wrapper around the shared DesignForm (SCRUM-903). */
const UpdateDesign = (props: UpdateDesignProps) => (
  <DesignForm
    mode="update"
    design={props.design}
    switchToDesignListHandler={props.switchToDesignListHandler}
  />
);

export default UpdateDesign;
